export default  {
  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <div>
        <div class="absolute top-0 left-0 w-full h-full bg-gray-900 opacity-50 z-30"></div>
        <div class="absolute w-full h-full top-0 left-0 overflow-y-auto z-40">
          <div class="-translate-y-1/2 -translate-x-1/2 transform w-10/12 lg:w-full absolute" style="top: 50%; left: 50%;">
            <div class="bg-white container md:max-w-5xl mx-auto rounded shadow-lg relative z-50">
              { this.$slots.default }
            </div>
          </div>
        </div>
      </div>
    );
  }
}
